import * as APIStore from "../../store/APIStore";

export const formatGreetingByPractice = (curGreeting: String,
    practice: APIStore.Practice,
    memberPCPcontact: APIStore.HNIProviderContact,
    refMd: APIStore.HNIProviderContact) => {
        
    if (!curGreeting)
        return ''

    if (practice.isRosterPractice) {

        if (memberPCPcontact && memberPCPcontact.lastName) {
            return `Dear Dr. ${memberPCPcontact.lastName}`
        }

        if (refMd && refMd.lastName) {
            return `Dear Dr. ${refMd.lastName}`
        }
    }

    return curGreeting;
}